import React, { useContext, useState } from 'react';
import { DatePicker, SecondaryButton } from '../../../../Core/FormInput';
import { Grid, InputLabel, FormHelperText } from '@material-ui/core';
import { postTCardsCloseDay, postTCardsCloseDayByCalID } from '../../../../Core/Service/TCardsCloseDay-service';
import AppContext from '../../../../App/AppContext';
import moment from 'moment';

function TCardsCloseDay(props) {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        date: moment(props.Date).format('YYYY-MM-DD'),
        calID: props.calID,
        errors: {}
    });

    console.log(props);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value
        }));
    };

    const handleValidation = () => {
        let formIsValid = true;
        // let errors = {};

        // if (!state.date) {
        //     formIsValid = false;
        //     errors.date = 'Date cannot be empty';
        // }
        // setState((st) => ({
        //     ...st,
        //     errors: errors
        // }));

        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (handleValidation()) {
            let res = await postTCardsCloseDayByCalID(state.calID);
            if (!res.success) {
                console.error(res);
                showToast('Error Setting Close Date');
            } else {
                // props.onFormSubmit(true);
                props.onClose(true);
                showToast('Close Date Set Successfully');
            }
        }
    };

    return (
        <div>
            <Grid item xs={12} md={12} lg={12}>
                <InputLabel className="mandatoryfields" style={{ marginBottom: 7 }}>
                    Date*
                </InputLabel>
                <DatePicker name="date" fullWidth value={state.date} disabled onChange={handleInput} />
                <FormHelperText error>{state.errors.date}</FormHelperText>
                <SecondaryButton className="Submitbtn" onClick={handleSubmit}>
                    Submit
                </SecondaryButton>
            </Grid>
        </div>
    );
}

export default TCardsCloseDay;
